// extracted by mini-css-extract-plugin
export var actionButton = "_f7-0";
export var fileInput = "_f7-2";
export var paperclip = "_f7-1";